/* eslint-disable no-var */
/********************************************************
 * VDM Configurator Control
 *
 * please add description of module here
 *
 ********************************************************/

/**********************************************
 DEPENDENCIES
**********************************************/

var $ = require('jquery');
var Ractive = require('ractive');
var utils = require('Utilities/utils');
var room_select = require('Modules/room_select');
var option_group = require('Modules/option_group_control');
var bt = require('Modules/button_toggle');
var api = require('Modules/api');
var modal = require('Modules/modal');
window.ds = require('Modules/data_store');
var rvalidate = require('Modules/rvalidate');
var template = require('Templates/configurator.html');

const WebGLViewport = require('Components/WebGLViewport');

/**********************************************
 VARIABLE DECLARATIONS
**********************************************/

var self = {};
window.static_data;
window.view;
window.user_config;
var last_room = null;
var cost_data = {
    base_price: 0,
    options: 0,
    entrance_fee: 0,
    total: 0
};
var export_form_toggle;
var options_type_id = 1;
var entrance_fee_type_id = '2';
var loading_cb;
var done_loading_cb;

var export_email_title = 'Email Sent';
var export_email_msg =
    'Check your email inbox for an email containing a PDF attachment detailing your unit configuration.';

/**********************************************
 HELPER FUNCTIONS
**********************************************/

// functions to be included in the data object passed to the ractive template
var helpers = {
    // update plain number to include dollar sign and needed commas
    to_dollar: function(number) {
        return '$ ' + Number(number).toLocaleString();
    },

    // check if this unit has any entrance fee associated option group
    has_entrance_fee: function() {
        var room_data = static_data.unit_data.rooms;

        for (var i = 0; i < room_data.length; i++) {
            for (var l = 0; l < room_data[i].option_groups.length; l++) {
                if (
                    room_data[i].option_groups[l].option_group_type_id ==
                    entrance_fee_type_id
                )
                    return true;
            }
        }
        return false;
    },

    // checks to see if an option item is the currently selected option in the group
    is_active_option: function(opt_grp_id, opt_id) {
        // get active room value
        var room_id = view.get('active_room_id');

        // get currently selected option for this option group
        var active_opt = view.get(
            'user_config.rooms.' + room_id + '.' + opt_grp_id
        );

        // if this option is the active one then turn on the indicator
        return active_opt == opt_id;
    },

    // return base room image
    get_base_image: function(room_id) {
        var active_room = utils.find_object_in_array(
            view.get('unit_data.rooms'),
            'id',
            room_id
        );
        return active_room['base_image_url'];
    },

    get_room: function(room_id) {
        var active_room = utils.find_object_in_array(
            view.get('unit_data.rooms'),
            'id',
            room_id
        );

        console.dir(active_room);
        return active_room;
    },

    // return option group array associated with specific room
    get_option_groups: function(room_id) {
        if (room_id != null) {
            var active_room = utils.find_object_in_array(
                view.get('unit_data.rooms'),
                'id',
                room_id
            );

            return active_room.option_groups;
        } else return [];
    },

    get_room_connections: function(room_id) {
        if (room_id != null) {
            var active_room = utils.find_object_in_array(
                view.get('unit_data.rooms'),
                'id',
                room_id
            );

            return active_room.room_connections;
        } else return [];
    },

    // return option array associated with specific room and option group
    get_options: function(room_id, og_id) {
        if (room_id != null) {
            var active_room = utils.find_object_in_array(
                view.get('unit_data.rooms'),
                'id',
                room_id
            );
            var active_og = utils.find_object_in_array(
                active_room.option_groups,
                'id',
                og_id
            );
            return active_og.options;
        } else return [];
    },

    // retrives image of selected option for a given option group
    og_image: function(opt_grp_id) {
        // get active room value
        var room_id = view.get('active_room_id');

        // get currently selected option for this option group
        var active_opt = view.get(
            'user_config.rooms[' + room_id + '][' + opt_grp_id + ']'
        );

        // get array of options in option group
        //var og_options = view.get('unit_data.rooms[' + room_id + '].option_groups[' + opt_grp_id + '].options');
        var active_room = utils.find_object_in_array(
            view.get('unit_data.rooms'),
            'id',
            room_id
        );
        var active_og = utils.find_object_in_array(
            active_room.option_groups,
            'id',
            opt_grp_id
        );
        var active_option = utils.find_object_in_array(
            active_og.options,
            'id',
            active_opt
        );

        // return image url if one define
        if (active_option.layer_image != null) return active_option.layer_image;
        else return false;
    },

    get_option: function(opt_grp_id) {
        // get active room value
        var room_id = view.get('active_room_id');

        // get currently selected option for this option group
        var active_opt = view.get(
            'user_config.rooms[' + room_id + '][' + opt_grp_id + ']'
        );

        // get array of options in option group
        //var og_options = view.get('unit_data.rooms[' + room_id + '].option_groups[' + opt_grp_id + '].options');
        var active_room = utils.find_object_in_array(
            view.get('unit_data.rooms'),
            'id',
            room_id
        );
        var active_og = utils.find_object_in_array(
            active_room.option_groups,
            'id',
            opt_grp_id
        );
        var active_option = utils.find_object_in_array(
            active_og.options,
            'id',
            active_opt
        );


        console.dir(active_option);

        return active_option;
    },
    openModal: function() {
        $('#processModal').modal()
    }

};

/**********************************************
 PRIVATE FUNCTIONS
**********************************************/

// get the show going and allow room selection
var prep_room_selection = function() {
    room_select.init();
    room_select.on_change(room_update);
};

// responds to room selections
var room_update = function(value, clicked) {
    clicked = utils.defPar(clicked, true);

    // hide form if visible
    hide_export_form();

    // update data model
    view.set('active_room_id', value);
    last_room = value;

    if (!clicked) room_select.set(value);

    // add class to og panel
    $('.og-panel').addClass('og-panel--visible');

    // get option panel ready
    prep_option_groups();
};

// prepares option group panel controller
var prep_option_groups = function() {
    // init option group panel
    option_group.init();

    // listen for option selection changes
    option_group.on_change(option_update);
};

// handles data and other tweaks when a new option selected
var option_update = function(opt_grp_id, opt_id) {
    // get active room
    var room_id = view.get('active_room_id');

    // update user config with new option selection
    view.set(
        'user_config.rooms[' + room_id + '][' + opt_grp_id + ']',
        Number(opt_id)
    );

    // update cost summaries
    cost_list_update();

    // call api with updated user config info
    update_save_data();
};

// update server with config data
var update_save_data = function() {
    var data = {};
    data.unit_id = view.get('unit_data.id');
    data.user_config = view.get('user_config');
    data.user_id = ds.get('token_payload').id;
    api.save_user_data(data).done(function(data) {
        console.log('- user data saved to server.');
    });
};

// updates cost list info when option selection are updated
var cost_list_update = function() {
    var user_config = view.get('user_config');
    var unit_data = view.get('unit_data');

    var options = 0;
    var entrance_fee = 0;

    // loop through rooms in user config
    for (var room in user_config.rooms) {
        // loop through option groups in that room
        for (var opt_grp in user_config.rooms[room]) {
            // get option id currently selected
            var opt_id = user_config.rooms[room][opt_grp];

            // get the type of the option group and the particular option object that is selected
            var active_room = utils.find_object_in_array(
                unit_data.rooms,
                'id',
                room
            );
            var active_og = utils.find_object_in_array(
                active_room.option_groups,
                'id',
                opt_grp
            );
            var option_group_type = active_og.option_group_type_id;
            var selected_option = utils.find_object_in_array(
                active_og.options,
                'id',
                opt_id
            );

            // update current cost with price of selected option
            if (option_group_type == 1) {
                if (selected_option.price != 1) {
                    options += parseFloat(selected_option.price);
                }
            } else if (option_group_type == 2) {
                entrance_fee += parseFloat(selected_option.price);
            }
        }
    }

    // update data model
    view.set('cost_data.options', options);
    view.set('cost_data.entrance_fee', entrance_fee);
};

// add export button listener
var prep_export_option = function() {
    // listen to export button
    $('#btn_export')
        .off()
        .on('click', show_export_form);
};

function setHeight(el, height) {
    var $el = $(el);

    $el.css('height', height);
    $el.css('max-height', height);
}

function refreshFormHeight() {
    var objHeight = 0;
    $.each($('.export-form').children(), function() {
        objHeight += $(this).outerHeight(true);
    });

    setHeight('.export-form', objHeight);
    setHeight('.vdm-image', objHeight);
}

function removeFormHeight() {
    setHeight('.export-form', '');
    setHeight('.vdm-image', '');
}

function price_rules(length) {
    length = length || 0;

    var rules = [];

    for (var i = 0; i < length; ++i) {
        rules.push(
            {
                input: 'export_form.prices[' + i + '].title',
                type: 'text',
                error: 'er.pn[' + i + ']',
                required: true
            },
            {
                input: 'export_form.prices[' + i + '].price',
                type: 'number',
                error: 'er.pp[' + i + ']',
                required: true,
                min: 0
            }
        );
    }

    return rules;
}

// display form and add some listeners and stuff
var show_export_form = function(e) {
    var payload = ds.get('token_payload');
    view.set('export_form', payload);

    if (view.get('user_config.notes') != '') {
        view.set('export_form.notes', view.get('user_config.notes'));
    }

    view.set('export_form.prices', view.get('user_config.prices'));
    view.set('export_form.unit_id', view.get('unit_data.id'));

    var export_mode =
        view.get('export_form.mode') != undefined
            ? view.get('export_form.mode')
            : 'email';

    // activate button toggle
    export_form_toggle = new bt({
        container: '#btn_grp_export_type',
        buttons: '.button',
        active: 'button--active',
        inactive: 'button--inactive',
        value: export_mode
    });
    export_form_toggle.addListener(function(val) {
        view.set('export_form.mode', val);
    });

    view.set('export_form.mode', export_mode);

    // allow content container to be full width
    $('.vdm-main').addClass('form-mode');

    // listen for submit button
    $('#export_submit')
        .off()
        .on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            // valid date form?
            var validate_rules = [
                {
                    input: 'export_form.email',
                    error: 'er.e',
                    type: 'email',
                    required: true
                }
            ];

            var form_data = view.get('export_form');

            // console.log(form_data);

            var valid = true;
            if (form_data.mode == 'email') {
                var valid = rvalidate.check(view, validate_rules);
            } else view.set('er.e', false);

            var prices_valid = rvalidate.check(
                view,
                price_rules((form_data.prices && form_data.prices.length) || 0)
            );

            valid = valid && prices_valid;

            if (valid) {
                loading_cb('Preparing Configuration Summary');
                api.request_export(form_data).done(function(data) {
                    if (data.data.pdf) {
                        // load in iframe
                        $('#pdf_download_frame').attr(
                            'src',
                            '/api/app/pdf_export/' + data.data.pdf
                        );

                        // would prefer to be able to fire this on conf that iframe loaded, but havevn't had luck yet.
                        setTimeout(function() {
                            if (last_room != null)
                                room_update(last_room, false);
                            else hide_export_form();
                            done_loading_cb();
                        }, 2000);
                    } else {
                        modal.alert(export_email_title, export_email_msg);
                        // return to last room if one selected, else back to instructions
                        if (last_room != null) room_update(last_room, false);
                        else hide_export_form();
                        done_loading_cb();
                    }
                });
            } else $('.vdm-main').animate({ scrollTop: 0 }, 'fast');
        });

    $('#comm_add_price')
        .off()
        .on('click', function(e) {
            e.preventDefault();

            view.push('export_form.prices', { title: '', price: 0 });

            refreshFormHeight();
        });

    $(document)
        .off()
        .on('click', '.comm_remove_price', function(e) {
            e.preventDefault();

            var index = +$(this).data('index');
            view.splice('export_form.prices', index, 1);
            refreshFormHeight();
        });

    // hide side form if needed
    $('.og-panel').removeClass('og-panel--visible');

    // clear active room
    view.set('active_room_id', null);
    room_select.clear();

    refreshFormHeight();
};

// hide export form and clean up
var hide_export_form = function() {
    if ($('.vdm-main').hasClass('form-mode')) {
        // kill button toggle
        export_form_toggle.kill();

        // remove form mode class
        $('.vdm-main').removeClass('form-mode');

        // temp save of entered notes into user_config
        view.set('user_config.notes', view.get('export_form.notes'));

        // clear listener submit button listener
        $('#export_submit').off();
        $('#comm_add_price').off();
        $('.comm_remove_price').off();

        removeFormHeight();
    }
};

// function loops through image array and then on load completion fires callback
var preload_images = function(preload, cb) {
    var promises = [];
    for (var i = 0; i < preload.length; i++) {
        (function(url, promise) {
            var img = new Image();
            img.onload = function() {
                promise.resolve();
            };
            img.src = url;
        })(preload[i], (promises[i] = $.Deferred()));
    }
    $.when.apply($, promises).done(function() {
        // done loading, remove cover and start loading option images
        if (cb) cb();
    });
};

// create image array of room base images and preloads them before loading firing callback
var preload_room_images = function(cb) {
    var img_array = [];

    for (var i = 0; i < static_data.unit_data.rooms.length; i++) {
        img_array.push(static_data.unit_data.rooms[i].base_image_url);
    }

    preload_images(img_array, function() {
        if (cb) cb();
        preload_option_images();
    });
};

// creates image array of option thumbnails and layer images to preload
var preload_option_images = function() {
    var img_array = [];

    // loop through rooms
    for (var i = 0; i < static_data.unit_data.rooms.length; i++) {
        // loop through option groups
        for (
            var l = 0;
            l < static_data.unit_data.rooms[i].option_groups.length;
            l++
        ) {
            // loop through options
            for (
                var r = 0;
                r <
                static_data.unit_data.rooms[i].option_groups[l].options.length;
                r++
            ) {
                var img =
                    static_data.unit_data.rooms[i].option_groups[l].options[r]
                        .layer_image;
                var tn =
                    static_data.unit_data.rooms[i].option_groups[l].options[r]
                        .tn_image;
                if (img != '') img_array.push(img);
                if (tn != '') img_array.push(tn);
            }
        }
    }

    preload_images(img_array, false);
};

var check_config = function(user_config, unit_data) {
    var valid = true;

    // check if room length is equal
    if (Object.keys(user_config.rooms).length != unit_data.rooms.length) {
        console.log('room count mismatch');
        return false;
    }

    // same number of rooms, now loop through them to check for matching ids
    for (var room in user_config.rooms) {
        var unit_data_room = utils.find_object_in_array(
            unit_data.rooms,
            'id',
            room
        );

        // check if room ids in user_config match those in unit_data
        if (!unit_data_room) {
            console.log('room id not found in unit config');
            return false;
        }

        // check if option group length is equal to what is expected.
        if (
            Object.keys(user_config.rooms[room]).length !=
            unit_data_room.option_groups.length
        ) {
            console.log('option group count does not match for room ' + room);
            return false;
        }

        // same number of option groups, now loop through them to check for matching ids
        for (var og in user_config.rooms[room]) {
            var unit_data_og = utils.find_object_in_array(
                unit_data_room.option_groups,
                'id',
                og
            );

            // check if og id in user_config matches those in unit_data
            if (!unit_data_og) {
                console.log('option group not id not found in unit config');
                return false;
            }

            // check if selected option id exists in unit_data
            var unit_data_option = utils.find_object_in_array(
                unit_data_og.options,
                'id',
                user_config.rooms[room][og]
            );

            if (!unit_data_option) {
                console.log('selected option not available in option group');
                return false;
            }
        }
    }

    return valid;
};

// configurator init
var init = function(ctx, config_data, ready_cb) {
    user_config = ds.ds_get('config');

    // if user data then check that it still aligns with current unit config
    if (user_config != null) {
        var valid = check_config(user_config, config_data.unit_data);

        if (!valid) {
            user_config = null;
            modal.alert(
                'Unit Has Changed',
                'The configuration of the unit has changed since your last save.  Because of this your unit configuration has been defaulted.'
            );
        } else {
            console.log('data is sound!');
        }
    }

    if (user_config == null) {
        // no existing data so build out base
        user_config = {
            unit_id: config_data.unit_data.id,
            rooms: {}
        };

        for (var i = 0; i < config_data.unit_data.rooms.length; i++) {
            // loop through and build an object for each room
            user_config.rooms[config_data.unit_data.rooms[i].id] = {};

            // loop through option groups and add to room object
            for (
                var l = 0;
                l < config_data.unit_data.rooms[i].option_groups.length;
                l++
            ) {
                var default_option_id;

                // loop through options in group and find one with default_item set
                for (
                    var r = 0;
                    r <
                    config_data.unit_data.rooms[i].option_groups[l].options
                        .length;
                    r++
                ) {
                    var sort_order =
                        config_data.unit_data.rooms[i].option_groups[l].options[
                            r
                        ].sort_order;
                    if (sort_order == 1) {
                        default_option_id =
                            config_data.unit_data.rooms[i].option_groups[l]
                                .options[r].id;
                    }
                }
                user_config.rooms[config_data.unit_data.rooms[i].id][
                    config_data.unit_data.rooms[i].option_groups[l].id
                ] = parseInt(default_option_id);
            }
        }
    }

    // prep data to be sent to template
    config_data.helpers = helpers;
    config_data.user_config = user_config;
    cost_data.base_price = Number(config_data.unit_data.base_price);
    config_data.cost_data = cost_data;
    config_data.active_room_id = null;

    // bad approach but make as static version of data that I can check without ractive view action
    static_data = config_data;

    // load and populate template
    view = new Ractive({
        el: '#container',
        template: template,
        data: config_data,
        components: { WebGLViewport }
    });

    // get ready to listen to room selections and export option
    prep_room_selection();
    prep_export_option();

    // preload images
    preload_room_images(ready_cb);

    // update cost info to reflect standard items with cost or existing user config
    cost_list_update();

    // save inital data to server
    update_save_data();
};

/**********************************************
 PUBLIC FUNCTIONS
**********************************************/

self.show = function(ctx, config_data, s_loading, s_done_loading) {
    loading_cb = s_loading;
    done_loading_cb = s_done_loading;

    // need to know if init with valid token
    if (ctx.params.tkn_valid) {
        var payload = ds.get('token_payload');

        // check for user data
        api.get_user_data(payload['id'], config_data.unit_data.id).done(
            function(data) {
                if (data.data != null) {
                    // save data and request if use or clear it
                    ds.ds_set('config', data.data);
                    init(ctx, config_data, s_done_loading);
                } else init(ctx, config_data, s_done_loading);
            }
        );
    } else init(ctx, config_data, s_done_loading);
};

/**********************************************
 Module Export
**********************************************/
module.exports = self;
